import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import moment from 'moment'
import _ from 'lodash'
import keycode from 'keycode'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableFooter from '@material-ui/core/TableFooter'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'
import Table from '@material-ui/core/Table'
import Checkbox from '@material-ui/core/Checkbox'
import Paper from '@material-ui/core/Paper'
import AdminTableActionToolbarComponent from './AdminTableActionToolbarComponent'
import AdminTableHeadComponent from './AdminTableHeadComponent'
import { pricingTypesMatcher } from 'utils/labelMatcher'
let counter = 0
const rowsPerPageOptions = [5, 10, 20, 30, 50, 100]
function createData(item) {
  counter += 1
  let data = { id: counter }
  for (var property in item) {
    if (item.hasOwnProperty(property)) {
      data[property] = item[property]
    }
  }
  return data
}
function createDataFromArray(list) {
  counter = 0
  let data = []
  list.forEach(item => data.push(createData(item)))
  return data
}
function createCellTable(classes, n, column, index) {
  const value = column.transform ? column.transform(n[column.id]) : n[column.id]
  if (column.id === 'color') {
    return (
      <TableCell
        key={index}
        padding={column.disablePadding ? 'none' : 'default'}
        numeric={column.numeric}>
        <div
          style={{ marginLeft: '10px', backgroundColor: value }}
          className={classes.color}
        />
      </TableCell>
    )
  }
  if (column.type === 'pricing') {
    return (
      <TableCell
        key={index}
        padding={column.disablePadding ? 'none' : 'default'}
        numeric={column.numeric}>
        {column.float
          ? Number(value).toFixed(column.float)
          : pricingTypesMatcher(n.type, true)}
      </TableCell>
    )
  }
  if (column.bool) {
    return (
      <TableCell
        key={index}
        padding={column.disablePadding ? 'none' : 'default'}
        numeric={column.numeric}>
        <Checkbox checked={value} disabled />
      </TableCell>
    )
  }
  if (column.expiration) {
    if (!value) {
      return (
        <TableCell
          key={index}
          padding={column.disablePadding ? 'none' : 'default'}
          numeric={!!column.numeric}>
          -
        </TableCell>
      )
    }
    const isValid = moment(value).isAfter(moment())
    return (
      <TableCell
        style={{ color: isValid ? 'green' : 'red' }}
        key={index}
        padding={column.disablePadding ? 'none' : 'default'}
        numeric={!!column.numeric}>
        {column.float
          ? Number(value).toFixed(column.float)
          : moment(value).format('DD/MM/YYYY')}
      </TableCell>
    )
  }
  return (
    <TableCell
      key={index}
      padding={column.disablePadding ? 'none' : 'default'}
      numeric={!!column.numeric}>
      {column.float ? Number(value).toFixed(column.float) : value}
    </TableCell>
  )
}
const styles = theme => ({
  root: {
    width: '100%'
  },
  table: {
    minWidth: 800
  },
  tableWrapper: {
    overflowX: 'auto'
  },
  color: {
    height: 20,
    width: 20,
    borderRadius: '50%'
  }
})
class AdminTableComponent extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    list: PropTypes.array.isRequired,
    columnData: PropTypes.array.isRequired,
    orderBy: PropTypes.string,
    title: PropTypes.string.isRequired,
    addButtonAction: PropTypes.func,
    editButtonAction: PropTypes.func,
    reOrderAction: PropTypes.func,
    deleteButtonAction: PropTypes.func,
    readOnly: PropTypes.bool,
    selectable: PropTypes.bool,
    search: PropTypes.array
  }
  static defaultProps = {
    orderBy: 'name',
    readOnly: false,
    selectable: false,
    search: []
  }
  constructor(props, context) {
    super(props, context)
    this.state = {
      order: 'asc',
      orderBy: props.orderBy || this.defaultProps.orderBy,
      selected: [],
      data: createDataFromArray(props.list).sort(
        (a, b) => (a[props.orderBy] < b[props.orderBy] ? -1 : 1)
      ),
      page: 0,
      rowsPerPage: rowsPerPageOptions[0],
      search: ''
    }
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.list !== nextProps.list) {
      const orderBy = nextProps.orderBy
      let rowsPerPage = rowsPerPageOptions[0]
      for (let i = 0; i < rowsPerPageOptions.length; i++) {
        if (rowsPerPageOptions[i] >= nextProps.list.length) {
          rowsPerPage = rowsPerPageOptions[i]
          break
        }
      }
      let transform = val => val
      const columnData = nextProps.columnData
        ? nextProps.columnData
        : this.props.columnData
      const column = columnData.find(column => column.id === orderBy)
      if (column && column.transform) {
        transform = column.transform
      }
      this.setState({
        selected: [],
        data: createDataFromArray(nextProps.list).sort(
          (a, b) => (transform(a[orderBy]) < transform(b[orderBy]) ? -1 : 1)
        ),
        rowsPerPage: rowsPerPage,
        orderBy: nextProps.orderBy
      })
    }
  }
  handleRequestSort = (event, property) => {
    let orderBy = property === 'pricingType' ? 'type' : property
    let transform = val => val
    const column = this.props.columnData.find(column => column.id === orderBy)
    if (column.transform) {
      transform = column.transform
    }
    let order = 'desc'

    if (this.state.orderBy === orderBy && this.state.order === 'desc') {
      order = 'asc'
    }

    const data =
      order === 'desc'
        ? this.state.data.sort(
            (a, b) => (transform(b[orderBy]) < transform(a[orderBy]) ? -1 : 1)
          )
        : this.state.data.sort(
            (a, b) => (transform(a[orderBy]) < transform(b[orderBy]) ? -1 : 1)
          )
    this.setState({ data, order, orderBy })
  }

  handleSelectAllClick = (event, checked) => {
    if (checked) {
      this.setState({ selected: this.state.data.map(n => n.id) })
      return
    }
    this.setState({ selected: [] })
  }

  handleKeyDown = (event, id) => {
    if (keycode(event) === 'space') {
      this.handleRowClick(event, id)
    }
  }
  handleEditButtonAction = () => {
    if (this.state.selected.length === 1) {
      const selectedData = this.state.data.filter(
        n => n.id === this.state.selected[0]
      )[0]
      if (selectedData) {
        delete selectedData.id
        this.props.editButtonAction(selectedData)
      }
    }
  }
  handleRowClick = (event, id) => {
    const { data } = this.state
    const selectedData = { ...data.filter(c => c.id === id)[0] }
    if (selectedData) {
      delete selectedData.id
      this.props.editButtonAction(selectedData)
    }
  }
  handleSelectClick = (event, id) => {
    event.stopPropagation()
    const { selected } = this.state
    const selectedIndex = selected.indexOf(id)
    let newSelected = []

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id)
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1))
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1))
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      )
    }

    this.setState({ selected: newSelected })
  }

  handleChangePage = (event, page) => {
    this.setState({ page })
  }

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value })
  }
  handleOnSearch = e => {
    this.setState({ searchInput: e.target.value })
  }
  isSelected = id => this.state.selected.indexOf(id) !== -1
  render() {
    const {
      classes,
      columnData,
      title,
      readOnly,
      selectable,
      search
    } = this.props
    const {
      data,
      order,
      orderBy,
      selected,
      rowsPerPage,
      page,
      searchInput
    } = this.state
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage)
    const filteredData =
      search.length > 0
        ? data.filter(n => {
            for (let i = 0; i < search.length; i++) {
              const column = columnData.find(column => column.id === search[i])
              if (column.transform) {
                if (
                  _.toLower(column.transform(n[search[i]])).includes(
                    _.toLower(searchInput)
                  )
                ) {
                  return true
                }
              }
              if (_.toLower(n[search[i]]).includes(_.toLower(searchInput))) {
                return true
              }
            }
            return false
          })
        : data
    return (
      <Paper className={classes.root}>
        <AdminTableActionToolbarComponent
          readOnly={readOnly}
          onSearch={search ? this.handleOnSearch : void 0}
          numSelected={selected.length}
          title={title}
          addButtonAction={this.props.addButtonAction}
          editButtonAction={this.handleEditButtonAction}
          reOrderAction={this.props.reOrderAction}
          deleteButtonAction={() =>
            this.props.deleteButtonAction(
              filteredData.filter(d => selected.includes(d.id))
            )
          }
        />
        <div className={classes.tableWrapper}>
          <Table className={classes.table}>
            <AdminTableHeadComponent
              selectable={selectable}
              readOnly={readOnly}
              columnData={columnData}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={this.handleSelectAllClick}
              onRequestSort={this.handleRequestSort}
              rowCount={filteredData.length}
            />
            <TableBody>
              {filteredData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map(n => {
                  const isSelected = this.isSelected(n.id)
                  return (
                    <TableRow
                      hover
                      onClick={event => this.handleRowClick(event, n.id)}
                      onKeyDown={event => this.handleKeyDown(event, n.id)}
                      role="checkbox"
                      aria-checked={isSelected}
                      tabIndex={-1}
                      key={n.id}
                      selected={isSelected}>
                      {readOnly || !selectable ? (
                        <TableCell padding="checkbox" />
                      ) : (
                        <TableCell padding="checkbox">
                          <Checkbox
                            onClick={event =>
                              this.handleSelectClick(event, n.id)
                            }
                            checked={isSelected}
                          />
                        </TableCell>
                      )}
                      {columnData.map((column, index) => {
                        return createCellTable(classes, n, column, index)
                      })}
                    </TableRow>
                  )
                })}
              {emptyRows > 0 && (
                <TableRow style={{ height: 49 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={rowsPerPageOptions}
                  count={data.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onChangePage={this.handleChangePage}
                  onChangeRowsPerPage={this.handleChangeRowsPerPage}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </div>
      </Paper>
    )
  }
}
export default withStyles(styles)(AdminTableComponent)



// WEBPACK FOOTER //
// ./src/routes/Admin/components/CommonComponents/AdminTableComponent.js